<template>
  <SectionBento04
    v-if="contextData"
    :title="contextData.title"
    :description="contextData.description"
    :thumbnail="contextThumbnail"
    :items="contextItems"
    :theme="theme"
  />
</template>

<script setup lang="ts">
  import type { ISuiteProps } from '@/components/Shared/Suite/type.ts';

  interface IItem {
    name: string;
    link: string;
    linkName?: string;
    trackingCode?: string;
  }

  interface ITakeNextStepData {
    title: string;
    description?: string;
    thumbnail: string;
    items: IItem[];
  }

  interface ITakeNextStep {
    component: 'take-next-step';
    meta: {
      navigable?: string;
    };
    data: ITakeNextStepData;
  }

  type IProps = ISuiteProps<ITakeNextStep>;

  const props = defineProps<IProps>();

  const solutionsStore = useSolutionsStore();
  const { themeStyle } = storeToRefs(solutionsStore);

  const { provideFormatUrl } = useFormatUrl();
  const { provideResponsiveImgUrl } = useSolutionsData();

  const contextData = computed((): ITakeNextStepData => props.suiteData.data);

  const contextItems = computed((): IItem[] =>
    contextData.value.items.map((item) => ({
      ...item,
      link: provideFormatUrl(item.link),
    }))
  );

  const contextThumbnail = computed((): string => {
    const { thumbnail } = contextData.value;
    if (!thumbnail) return '';
    return provideResponsiveImgUrl(thumbnail);
  });

  const theme = computed((): TTheme => {
    switch (themeStyle.value) {
      case 'sustainable':
        return 'green';
      case 'connected':
        return 'cyan';
      case 'ai':
        return 'purple';
      case 'operations':
        return 'yellow';
      default:
        return 'blue';
    }
  });

  export type { IItem, ITakeNextStep, ITakeNextStepData };
</script>
